import { ActionTypes } from './actionTypes';
import type { ChangeGeofenceAddressRequest, ChangeGeofenceAddressSucceeded, ChangeGeofenceCoordinateRequest, ChangeGeofenceCoordinateSucceeded, ClearGeofence } from './actions';

import type { Geofence } from '@cobliteam/common-types';

export const changeGeofenceAddressRequest = (geofence: Geofence): ChangeGeofenceAddressRequest => ({
  type: ActionTypes.CHANGE_GEOFENCE_ADDRESS_REQUEST,
  payload: geofence,
});

export const changeGeofenceAddressSucceeded = (geofence: Geofence): ChangeGeofenceAddressSucceeded => ({
  type: ActionTypes.CHANGE_GEOFENCE_ADDRESS_SUCCEEDED,
  payload: geofence,
});

export const changeGeofenceCoordinateRequest = (geofence: Geofence): ChangeGeofenceCoordinateRequest => ({
  type: ActionTypes.CHANGE_GEOFENCE_COORDINATE_REQUEST,
  payload: geofence,
});

export const changeGeofenceCoordinateSucceeded = (geofence: Geofence): ChangeGeofenceCoordinateSucceeded => ({
  type: ActionTypes.CHANGE_GEOFENCE_COORDINATE_SUCCEEDED,
  payload: geofence,
});

export const clearGeofence = (): ClearGeofence => ({
  type: ActionTypes.CLEAR_GEOFENCE,
});
